import { render, staticRenderFns } from "./DiscussionCreateForm.vue?vue&type=template&id=d7d3c598&"
import script from "./DiscussionCreateForm.vue?vue&type=script&lang=js&"
export * from "./DiscussionCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionCreateForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7d3c598')) {
      api.createRecord('d7d3c598', component.options)
    } else {
      api.reload('d7d3c598', component.options)
    }
    module.hot.accept("./DiscussionCreateForm.vue?vue&type=template&id=d7d3c598&", function () {
      api.rerender('d7d3c598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/discussion/DiscussionCreateForm.vue"
export default component.exports